(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-complementary"]) return;
  try {
    
  const complementaryProductsSection = document.querySelector('.complementary-products');

  if (complementaryProductsSection) {
    const url = complementaryProductsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const complementary = html.querySelector('.complementary-products');

        if (complementary && complementary.innerHTML.trim().length) {
          complementaryProductsSection.innerHTML = complementary.innerHTML;
        } else {
          complementaryProductsSection.closest('.shopify-section').remove();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        } else {
          productRecommendationsSection.closest('.shopify-section').remove();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  } catch(e) { console.error(e); }
})();
})();
